import { Injectable } from '@angular/core';
import { Observable, of, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IBanco, IBancoResponse, IBancoRequest } from '../interfaces/banco.interface';

@Injectable({
  providedIn: 'root'
})
export class BancoService {
  
  private readonly API_URL = `${environment.apiNewBackBaseUrl}Acciones/`;
  
  constructor(private http: HttpClient) { }

  getBancosDefault(): Observable<IBancoResponse> {
    const payload: IBancoRequest = {
      que: 4,
      tope: "9999",
      banco: "",
      nombre: "",
      tipoTarjeta: "",
      numeroCuenta: "",
      cuentaContable: "",
      iOrigenMov: 0,
      iOrigenDisp: 0
    };

    return this.http.post<any>(`${this.API_URL}GetBancsLST`, payload).pipe(
      map(response => {
        // El API retorna success: false pero sí tiene datos
        // Consideramos exitoso si hay datos en el array
        const hasData = response.data && Array.isArray(response.data) && response.data.length > 0;
        
        return {
          success: hasData,
          data: response.data || [],
          message: hasData ? 'Datos cargados correctamente' : 'No se encontraron datos'
        } as IBancoResponse;
      })
    );
  }

  deleteBanco(banco: string): Observable<IBancoResponse> {
    const payload: IBancoRequest = {
      que: 3,
      tope: "",
      banco: banco,
      nombre: "",
      tipoTarjeta: "",
      numeroCuenta: "",
      cuentaContable: "",
      iOrigenMov: 0,
      iOrigenDisp: 0
    };

    return this.http.post<any>(`${this.API_URL}GetBancsErr`, payload).pipe(
      map(response => {
        const hasErrors = response.data && Array.isArray(response.data) && response.data.length > 0;
        const isSuccess = hasErrors && response.data[0]?.error === "0";
        
        return {
          success: isSuccess,
          data: [],
          message: isSuccess ? 
            'Banco eliminado correctamente' : 
            `Error al eliminar el banco: ${response.data[0]?.error || 'Error desconocido'}`
        } as IBancoResponse;
      })
    );
  }

  createBanco(banco: IBanco): Observable<IBancoResponse> {
    const payload: IBancoRequest = {
      que: 1,
      tope: "",
      banco: banco.banco,
      nombre: banco.nombre,
      tipoTarjeta: banco.tipoTarjeta,
      numeroCuenta: banco.numeroCuenta,
      cuentaContable: banco.cuentaContable,
      iOrigenMov: banco.iOrigenMov,
      iOrigenDisp: banco.iOrigenDisp
    };

    return this.http.post<any>(`${this.API_URL}GetBancsErr`, payload).pipe(
      map(response => {
        const hasErrors = response.data && Array.isArray(response.data) && response.data.length > 0;
        const isSuccess = hasErrors && response.data[0]?.error === "0";
        
        return {
          success: isSuccess,
          data: [],
          message: isSuccess ? 
            'Banco creado correctamente' : 
            `Error al crear el banco: ${response.data[0]?.error || 'Error desconocido'}`
        } as IBancoResponse;
      })
    );
  }

  updateBanco(banco: IBanco): Observable<IBancoResponse> {
    const payload: IBancoRequest = {
      que: 2,
      tope: "",
      banco: banco.banco,
      nombre: banco.nombre,
      tipoTarjeta: banco.tipoTarjeta,
      numeroCuenta: banco.numeroCuenta,
      cuentaContable: banco.cuentaContable,
      iOrigenMov: banco.iOrigenMov,
      iOrigenDisp: banco.iOrigenDisp
    };

    return this.http.post<any>(`${this.API_URL}GetBancsErr`, payload).pipe(
      map(response => {
        const hasErrors = response.data && Array.isArray(response.data) && response.data.length > 0;
        const isSuccess = hasErrors && response.data[0]?.error === "0";
        
        return {
          success: isSuccess,
          data: [],
          message: isSuccess ? 
            'Banco actualizado correctamente' : 
            `Error al actualizar el banco: ${response.data[0]?.error || 'Error desconocido'}`
        } as IBancoResponse;
      })
    );
  }
}
